"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _clsx = _interopRequireDefault(require("clsx"));
var _commonMedia = _interopRequireDefault(require("../styles/common-media.css"));
var _backgroundImage = _interopRequireDefault(require("./background-image"));
var _videoBackground = _interopRequireDefault(require("./video-background"));
var _youtubeVideo = _interopRequireDefault(require("./youtube-video"));
var _commonMedia2 = require("./common-media.props/common-media.propTypes");
var _DataUtils = new _mmcDataUtilities["default"](),
  handleNestedProp = _DataUtils.handleNestedProp;
var CommonMedia = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(CommonMedia, _React$Component);
  function CommonMedia() {
    return _React$Component.apply(this, arguments) || this;
  }
  CommonMedia.resourceType = function resourceType() {
    return 'CommonMedia_1_0_0';
  };
  var _proto = CommonMedia.prototype;
  _proto.chooseMediaType = function chooseMediaType(switchCase) {
    var props = this.props;
    var theme = props.theme,
      mediaClasses = props.mediaClasses,
      market = props.config.market;
    switch (switchCase) {
      case 'video.youtubeVideoId':
        return /*#__PURE__*/_react["default"].createElement(_youtubeVideo["default"], {
          youtubeVideoId: props.video.youtubeVideoId,
          market: market,
          classes: (0, _clsx["default"])(mediaClasses)
        });
      case 'video.source':
        return /*#__PURE__*/_react["default"].createElement(_videoBackground["default"], {
          data: props,
          theme: theme,
          classes: (0, _clsx["default"])(mediaClasses),
          hideVideoOnMobile: handleNestedProp(props, 'props.hideVideoOnMobile'),
          autoPlayVideoOnMobile: handleNestedProp(props, 'props.autoPlayVideoOnMobile')
        });
      case 'image.image':
        return /*#__PURE__*/_react["default"].createElement(_backgroundImage["default"], {
          theme: theme,
          image: handleNestedProp(props, 'props.image.image'),
          altText: handleNestedProp(props, 'props.image.altText'),
          size: props.size,
          sizes: props.sizes,
          imageQuality: props.imageQuality,
          classes: (0, _clsx["default"])(mediaClasses)
        });
      default:
        return '';
    }
  };
  _proto.renderDesiredMediaType = function renderDesiredMediaType() {
    var props = this.props;
    var mediaSourceOrder = props.mediaSourceOrder || ['video.youtubeVideoId', 'video.source', 'image.image'];

    // first we select the data from the larger query coming through
    var mediaTypeIndex = null;
    for (var i = 0; i < mediaSourceOrder.length; i += 1) {
      var mediaSource = handleNestedProp(props, "props." + mediaSourceOrder[i]);
      if (mediaSource !== ' ' && mediaSource !== '' && mediaSource !== null) {
        mediaTypeIndex = i;
        break;
      }
    }
    return this.chooseMediaType(mediaSourceOrder[mediaTypeIndex]);
  };
  _proto.renderProportionalContainer = function renderProportionalContainer(aspectRatioPerentage) {
    var containerClasses = this.props.containerClasses;
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        paddingTop: aspectRatioPerentage + "%"
      },
      className: (0, _clsx["default"])(_commonMedia["default"].proportionalContainer, containerClasses)
    }, this.renderDesiredMediaType());
  };
  _proto.render = function render() {
    var aspectRatio = this.props.aspectRatio;
    var aspectRatioPerentage = null;
    if (aspectRatio !== undefined && aspectRatio !== null && aspectRatio !== '' && aspectRatio !== ' ') {
      if (typeof aspectRatio === 'string') {
        var aspectRatioArray = aspectRatio.split(':');
        aspectRatioPerentage = aspectRatioArray[1] / aspectRatioArray[0] * 100;
      } else if (typeof aspectRatio === 'number') {
        aspectRatioPerentage = aspectRatio;
      }
    }
    return aspectRatioPerentage === null ? this.renderDesiredMediaType() : this.renderProportionalContainer(aspectRatioPerentage);
  };
  return CommonMedia;
}(_react["default"].Component);
CommonMedia.displayName = 'CommonMedia';
var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(CommonMedia);
exports["default"] = _default;